/** Offset of `timeZone` from UTC at `instant`, in milliseconds. */
function offsetMs(instant: number, timeZone: string): number {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hourCycle: 'h23',
  }).formatToParts(instant);
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    Number(parts.find((p) => p.type === type)?.value);
  const wallClock = Date.UTC(
    part('year'),
    part('month') - 1,
    part('day'),
    part('hour'),
    part('minute'),
    part('second'),
  );
  return wallClock - Math.floor(instant / 1000) * 1000;
}

/**
 * The instant of a slot offered on the booking page. Slots are the business's wall-clock time, so
 * they convert using its timezone, not the visitor's. A missing or unrecognised timezone is read
 * as UTC, which is what `createBooking` does.
 */
export function listingTimeToInstant(date: string, time: string, timeZone?: string | null): Date {
  const [year, month, day] = date.split('-').map(Number);
  const [hour, minute] = time.split(':').map(Number);
  const wallClock = Date.UTC(year, month - 1, day, hour, minute);

  try {
    // The offset at the wall-clock guess can be on the wrong side of a DST change, so take it twice.
    const first = wallClock - offsetMs(wallClock, timeZone || 'UTC');
    return new Date(wallClock - offsetMs(first, timeZone || 'UTC'));
  } catch {
    return new Date(wallClock);
  }
}
